import React from 'react';

const TextItalic = ({ color, onClick }) => {
  return (
    <svg
      id='Component_496_4'
      data-name='Component 496 – 4'
      xmlns='http://www.w3.org/2000/svg'
      width='10.196'
      height='11.895'
      viewBox='0 0 10.196 11.895'
      style={{ marginTop: '5px' }}
      onClick={onClick}
      cursor='pointer'
    >
      <path
        id='Path_61986'
        data-name='Path 61986'
        d='M9.4,4V6.549h1.878l-2.906,6.8H6V15.9h6.8V13.346H10.92l2.906-6.8H16.2V4Z'
        transform='translate(-6 -4)'
        fill={color}
      />
    </svg>
  );
};

export default TextItalic;
